import { render, staticRenderFns } from "./MonthReport.vue?vue&type=template&id=2ec4b5c6&"
import script from "./MonthReport.vue?vue&type=script&lang=js&"
export * from "./MonthReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports